module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('a', {
    attrs: {
      "href": "#/005_Preface#fm-1"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/006_Chapter01#ch-1"
    }
  }, [_vm._v("1 "), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Thirty Years That Changed the World")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Chapter02#ch-2"
    }
  }, [_vm._v("2 "), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Bridges and Ditches in First Century Society")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Chapter03#ch-3"
    }
  }, [_vm._v("3 "), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Luke and His Friends")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 "), _c('span', {
    staticClass: "pad"
  }, [_vm._v("What of Their Approach?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter05#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 "), _c('span', {
    staticClass: "pad"
  }, [_vm._v("What of Their Lifestyle?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter06#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 "), _c('span', {
    staticClass: "pad"
  }, [_vm._v("What of Their Message?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter07#ch-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 "), _c('span', {
    staticClass: "pad"
  }, [_vm._v("What of Their Apologetics?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter08#ch-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 "), _c('span', {
    staticClass: "pad"
  }, [_vm._v("What of Their Methods?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter09#ch-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 "), _c('span', {
    staticClass: "pad"
  }, [_vm._v("What of Their Church Planting?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter10#ch-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 "), _c('span', {
    staticClass: "pad1"
  }, [_vm._v("What of Their Pastoral Care?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter11#ch-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 "), _c('span', {
    staticClass: "pad1"
  }, [_vm._v("What of Their Church Life?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter12#ch-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 "), _c('span', {
    staticClass: "pad1"
  }, [_vm._v("What of Their Leadership?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter13#ch-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 "), _c('span', {
    staticClass: "pad1"
  }, [_vm._v("What of Their Hardships?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter14#ch-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 "), _c('span', {
    staticClass: "pad1"
  }, [_vm._v("What of the Holy Spirit?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter15#ch-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15 "), _c('span', {
    staticClass: "pad1"
  }, [_vm._v("What of Their Priorities?")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6400504c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/003_Contents.vue
// module id = 69
// module chunks = 0